import React from 'react';
import TemplateCard from '../../@extended/TemplateCard';
import intergalacticCertificateImage320w from '../../../images/certificate-awarded-elon_lvpkde_c_scale,w_977.jpg';

export default function IntergalacticCertificate() {
  return (
    <TemplateCard
      imageLink={intergalacticCertificateImage320w}
      downloadLink="/templates/certificate_template.docx"
      title="CERTIFICATE OF INTERGALACTIC EXCELLENCE"
      description="This playful Certificate of&#160;Intergalactic Excellence is&#160;for visionaries transforming our world and beyond. It's a&#160;tongue-in-cheek tribute to&#160;those leading innovations in&#160;space exploration and sustainable technology. Celebrating imaginative minds, this certificate, humorously issued from Earth's orbit, honors extraordinary efforts in&#160;shaping a&#160;futuristic, adventurous world."
    />
  );
}
